import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Image,
  Typography,
  notification,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import googleIcon from "../../assets/signInIcon/google-icon.svg";
import facebookIcon from "../../assets/signInIcon/facebook-icon.svg";
import metamaskIcon from "../../assets/signInIcon/metamask-icon.svg";
import "./modalStyle.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { userActions } from "../../store/user";
import userSelectors from "../../store/user/selectors";
import SignUpForm from "./SignUpForm";
import { useNavigate } from "react-router-dom";
import axios, { AxiosError } from "axios";
import APIURL from "../../utils/getApiURL";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "@greatsumini/react-facebook-login";
import UserInfoForm from "./UserInfoForm";
interface singInInterface {
  email: `${string | number}@${string}.${string}`;
  password: string;
}
const SignInForm: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const signInModalVisible = useAppSelector(userSelectors.signInModal);
  const [forgotpassword, setForgotPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const loader = useAppSelector(userSelectors.getLoader);
  const referralCode = localStorage.getItem("referral_code");
  const [buttonClicked, setButtonClicked] = useState("");
  const authUser = useAppSelector(userSelectors.getUserDetails);
  const isAuthenticated = useAppSelector(userSelectors.getIsAutheticated);

  const navigateToPath = (path: string) => {
    dispatch(userActions.signInModal({ visible: false }));
    navigate(path);
  };

  const [signForm] = Form.useForm();
  const [forgotPasswordForm] = Form.useForm();
  const onFinish = (values: singInInterface) => {
    setButtonClicked("emailBtn");
    if (values.email.includes("+")) {
      notification.error({
        message: "Invalid Email",
        description:
          "Email addresses with '+' are not allowed. Please enter a valid email.",
        placement: "topRight",
      });
      return;
    }

    dispatch(
      userActions.signIn({
        email: values.email,
        password: values.password,
      })
    );
    signForm.resetFields();
  };
  const onFinishForgotPassword = async (values: { email: string }) => {
    if (loading) return;
    setLoading(true);

    try {
      await axios.post(`${APIURL}/auth/user/forgot-password/`, {
        email: values.email,
      });
      notification.success({
        message: "Password reset instructions have been sent to your email.",
      });
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{
          message?: string;
          non_field_errors?: string[];
        }>;
        if (axiosError.response) {
          const responseData = axiosError.response.data;
          if (
            responseData.non_field_errors &&
            responseData.non_field_errors.length > 0
          ) {
            errorMessage = responseData.non_field_errors[0];
          } else if (responseData.message) {
            errorMessage = responseData.message;
          }
        }
      }

      notification.error({ message: errorMessage });
    } finally {
      setLoading(false);
      setForgotPassword(false);
      forgotPasswordForm.resetFields();
    }
  };
  const responseGoogle = async (authResult: any) => {
    try {
      if (authResult["code"]) {
        dispatch(
          userActions.googleSignUp({
            code: authResult.code,
            referralCode: referralCode ? referralCode : "",
          })
        );
      } else {
        throw new Error(authResult);
      }
    } catch (e) {
      throw new Error("Error while Signin with Google...");
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: responseGoogle,
    onError: responseGoogle,
    flow: "auth-code",
  });

  const FacebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
  const registerWithFacebook = async (authResult: any) => {
    try {
      if (authResult["accessToken"]) {
        dispatch(
          userActions.facebookSignUp({
            access_token: authResult.accessToken,
            referralCode: referralCode ? referralCode : "",
          })
        );
      } else {
        throw new Error(authResult);
      }
    } catch (e) {
      console.log("Error while Facebook Login...", e);
    }
  };

  const metamaskLogin = async () => {
    if (!window.ethereum) return alert("Please install MetaMask");

    // Connect to MetaMask
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const address = accounts[0];

    dispatch(userActions.fetchMetamaskNonce({ address: address }));
  };

  useEffect(() => {
    if (authUser && isAuthenticated) {
      navigate("/");
      dispatch(userActions.signInModal({ visible: false }));
    }
  }, [dispatch, navigate, authUser, isAuthenticated]);

  return (
    <>
      <SignUpForm />
      <UserInfoForm />
      <Modal
        title="Login"
        visible={signInModalVisible}
        transitionName=""
        centered={true}
        onCancel={() => {
          dispatch(userActions.signInModal({ visible: false }));
          signForm.resetFields();
        }}
        footer={null}
      >
        <Form form={signForm} layout={"vertical"} onFinish={onFinish}>
          <Row gutter={[0, 20]}>
            <Col span={24}>
              <Space direction="vertical">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: "Email field is required!" },
                    { type: "email", message: "Invaid email id!" },
                  ]}
                >
                  <Input
                    type="email"
                    className="email-input"
                    placeholder="Email address"
                  ></Input>
                </Form.Item>
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Password field is required!",
                    },
                  ]}
                >
                  <Input.Password
                    iconRender={(visible) =>
                      visible ? (
                        <EyeInvisibleOutlined style={{ color: "#707070" }} />
                      ) : (
                        <EyeOutlined style={{ color: "#707070" }} />
                      )
                    }
                    type="password"
                    className="email-input"
                    placeholder="Password"
                  ></Input.Password>
                </Form.Item>
                <Typography.Link
                  onClick={() => {
                    setForgotPassword(true);
                    dispatch(userActions.signInModal({ visible: false }));
                  }}
                  style={{ float: "right", color: "#131314" }}
                >
                  Forgot Password?
                </Typography.Link>
              </Space>
            </Col>
            <Col span={24}>
              <Form.Item>
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "emailBtn" && loader ? true : false
                  }
                  disabled={loader}
                  htmlType={"submit"}
                >
                  Continue with email
                </Button>
              </Form.Item>
            </Col>
            <Col span={24}>
              <p className="continue-text">
                Don't have an account?{" "}
                <span
                  className="primary-color"
                  onClick={() => {
                    dispatch(userActions.signUpModal({ visible: true }));
                    dispatch(userActions.signInModal({ visible: false }));
                  }}
                >
                  Sign up
                </span>
              </p>
            </Col>
            <Col span={24}>
              <hr className="or-text" />
            </Col>
            <Col span={24}>
              <div className="social-button-container">
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "googleBtn" && loader ? true : false
                  }
                  disabled={loader}
                  onClick={() => {
                    setButtonClicked("googleBtn");
                    googleLogin();
                  }}
                >
                  <Image
                    src={googleIcon}
                    preview={false}
                    className="social-submit-button"
                  />
                  Continue with Google
                </Button>
                <FacebookLogin
                  className="facebook-submit-button"
                  appId={`${FacebookAppId}`}
                  onSuccess={async (response) => {
                    setButtonClicked("facebookBtn");
                    await registerWithFacebook(response);
                  }}
                  onFail={(error) => {
                    console.log("Login Failed!", error);
                  }}
                >
                  <Button
                    className="submit-button"
                    loading={
                      buttonClicked === "facebookBtn" && loader ? true : false
                    }
                    disabled={loader}
                  >
                    <Image
                      src={facebookIcon}
                      preview={false}
                      className="social-submit-button"
                    />
                    Continue with Facebook
                  </Button>
                </FacebookLogin>
                <Button
                  className="submit-button"
                  loading={
                    buttonClicked === "metamaskBtn" && loader ? true : false
                  }
                  disabled={loader}
                  onClick={() => {
                    setButtonClicked("metamaskBtn");
                    metamaskLogin();
                  }}
                >
                  <Image
                    src={metamaskIcon}
                    preview={false}
                    style={{ cursor: "pointer" }}
                    className="social-submit-button"
                  />
                  Continue with Metamask
                </Button>
              </div>
            </Col>
            <Col span={24}>
              <p className="continue-text">
                By continuing you agree to haveto.com's <br />
                <span className="imp-link">User Agreement</span>,{" "}
                <span className="imp-link">Wallet Services Terms</span> and{" "}
                <span
                  className="imp-link"
                  onClick={() => {
                    navigateToPath("/privacy-policy");
                  }}
                >
                  Privacy policy
                </span>
              </p>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title="Forgot Password"
        visible={forgotpassword}
        transitionName=""
        centered={true}
        onCancel={() => setForgotPassword(false)}
        footer={null}
      >
        <Form
          form={forgotPasswordForm}
          layout={"vertical"}
          onFinish={onFinishForgotPassword}
        >
          <Row gutter={[0, 20]}>
            <Col span={24}>
              <p className="continue-text">
                Enter your email address and we will send you a link to reset
                your password.
              </p>
            </Col>
            <Col span={24}>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Email field is required!" },
                  { type: "email", message: "Invalid email id!" },
                ]}
              >
                <Input
                  type="email"
                  className="email-input"
                  placeholder="Email address"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item>
                <Button
                  className="submit-button"
                  loading={loader}
                  onClick={forgotPasswordForm.submit}
                  htmlType={"submit"}
                >
                  Reset Password
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default SignInForm;
